module.exports = __webpack_public_path__ + "media/Activate.ef779513.wav";